module.exports = __webpack_public_path__ + "img/old_cuban.c54023cd.jpg";